import * as React from "react";

// @mui material components
import Paper from "@mui/material/Paper";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBedPulse } from "@fortawesome/free-solid-svg-icons";
import {
  faStethoscope,
  faBoxesStacked,
  faList,
  faHouse,
} from "@fortawesome/pro-solid-svg-icons";
import { useNavigate } from "react-router-dom";

import { styled } from "@mui/material/styles";

const MyBottomNavigationAction = styled(BottomNavigationAction)(
  ({ theme }) => ({
    color: theme.functions.rgba(theme.palette.dark.main, 0.5),
    minWidth: 0,
    padding: "6px 0 8px",
    borderRadius: theme.borders.borderRadius.xl,
    transition: "color 200ms ease, background-color 200ms ease",
    "& .MuiBottomNavigationAction-label": {
      fontSize: "0.6rem",
      fontWeight: 600,
      letterSpacing: "0.02em",
      marginTop: "3px",
    },
    "&:hover": {
      color: theme.palette.primary.main,
      backgroundColor: theme.functions.rgba(theme.palette.primary.main, 0.05),
    },
    "&.Mui-selected": {
      color: theme.palette.primary.main,
      backgroundColor: theme.functions.rgba(theme.palette.primary.main, 0.1),
    },
  })
);

function Footer() {
  const paths = window.location.pathname.split("/");
  const path = paths[1] ? paths[1] : "";
  const navigate = useNavigate();
  const [footerNavValue, setFooterNavValue] = React.useState(path);

  const handleChange = (event, newValue) => {
    setFooterNavValue(newValue);
    navigate(`/${newValue}`);
  };

  return (
    <Paper
      square
      elevation={0}
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: (theme) =>
          theme.functions.rgba(theme.palette.white.main, 0.85),
        backdropFilter: "blur(14px)",
        borderTop: (theme) =>
          `1px solid ${theme.functions.rgba(theme.palette.dark.main, 0.08)}`,
        boxShadow: (theme) =>
          `0 -8px 24px -16px ${theme.functions.rgba(
            theme.palette.dark.main,
            0.4
          )}`,
        pb: "env(safe-area-inset-bottom)",
      }}
    >
      <BottomNavigation
        showLabels
        sx={{ width: "100%", backgroundColor: "transparent", px: 0.5, gap: 0.5 }}
        value={footerNavValue}
        onChange={handleChange}
      >
        <MyBottomNavigationAction
          label="Home"
          value="dashboard"
          icon={<FontAwesomeIcon icon={faHouse} size="lg" />}
        />
        <MyBottomNavigationAction
          label="Rx"
          value="prescribers"
          icon={<FontAwesomeIcon icon={faStethoscope} size="lg" />}
        />
        <MyBottomNavigationAction
          label="Patients"
          value="patients"
          icon={<FontAwesomeIcon icon={faBedPulse} size="lg" />}
        />
        <MyBottomNavigationAction
          label="Service"
          value="service"
          icon={<FontAwesomeIcon icon={faList} size="lg" />}
        />
        <MyBottomNavigationAction
          label="Inventory"
          value="inventory"
          icon={<FontAwesomeIcon icon={faBoxesStacked} size="lg" />}
        />
      </BottomNavigation>
    </Paper>
  );
}

export default Footer;
